import React from 'react';
import { useSubscription } from '@/contexts/SubscriptionContext';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { Clock, Sparkles, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

export const TrialExpiryBanner = () => {
  const { isTrialActive, trialEndDate, hasAITherappiAccess } = useSubscription();
  const navigate = useNavigate();
  const [isDismissed, setIsDismissed] = useState(false);

  if (!isTrialActive || !trialEndDate || isDismissed || hasAITherappiAccess()) {
    return null;
  }

  const trialEnd = new Date(trialEndDate);
  const now = new Date();
  const daysLeft = Math.ceil((trialEnd.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));

  // Don't show if trial has already expired
  if (daysLeft < 0) return null;

  const getBannerStyle = () => {
    if (daysLeft <= 3) return 'bg-gradient-to-r from-primary/10 to-primary/5 border-primary/30';
    if (daysLeft <= 7) return 'bg-gradient-to-r from-secondary/10 to-accent/10 border-secondary/30';
    return 'bg-gradient-to-r from-muted/10 to-accent/10 border-muted/30';
  };

  const getMessage = () => {
    if (daysLeft === 0) return "Your free trial ends today";
    if (daysLeft === 1) return "Your free trial ends tomorrow";
    return `Your free trial ends in ${daysLeft} days`;
  };

  return (
    <div className={`relative border-b ${getBannerStyle()} animate-in fade-in slide-in-from-top-2 duration-500`}>
      <Alert className="border-0 bg-transparent rounded-none py-3">
        <div className="flex items-center justify-between gap-4 px-4">
          <div className="flex items-center gap-3 flex-1">
            <Clock className="h-5 w-5 text-primary" />
            <AlertDescription className="text-sm font-medium m-0">
              <span className="text-foreground">{getMessage()}</span>
              <span className="text-muted-foreground mx-2">•</span>
              <span className="text-muted-foreground">Subscribe anytime to keep full access to AI Therappi® and all features</span>
            </AlertDescription>
          </div>
          
          <div className="flex items-center gap-2">
            <Button 
              size="sm" 
              onClick={() => navigate('/subscription')}
              className="gap-2 bg-primary hover:bg-primary/90 text-primary-foreground shadow-sm"
            >
              <Sparkles className="h-4 w-4" />
              View Plans
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setIsDismissed(true)}
              className="h-8 w-8 p-0"
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </Alert>
    </div>
  );
};